/**
*****************************************
*										*
* NAGARRO  - CSX - CONFIDENTIAL         *
*										*
*****************************************
*/
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { ConfigService } from '../../../core/services/config.service';
import { TrainData } from '../../../core/model/train-data.model';

/**
 * @export
 * @class LmsTrainLocoDetailsHeaderComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-train-loco-details-header',
  templateUrl: './lms-train-loco-details-header.component.html',
  styleUrls: ['./lms-train-loco-details-header.component.scss']
})
export class LmsTrainLocoDetailsHeaderComponent implements OnInit, OnDestroy {

  @Input() trainData: TrainData;
  locoLabel: any;

  /**
   * Creates an instance of LmsTrainLocoDetailsHeaderComponent.
   * @param {ConfigService} configService
   * @memberOf LmsTrainLocoDetailsHeaderComponent
   */
  constructor(private configService: ConfigService) {
    this.locoLabel = this.configService.getConfigData().locoLabel;
  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LmsTrainLocoDetailsHeaderComponent
   */
  ngOnInit() {
  }

  /**
   * Clean the state of lifecycle hook.
   * @memberOf LmsTrainLocoDetailsHeaderComponent
   */
  ngOnDestroy() {
  }

}
